// Generated by purs version 0.13.8
"use strict";
var small = "small";
var large = "large";
module.exports = {
    large: large,
    small: small
};
